import { Box, Button, Divider, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
import { LogoOnly } from '@shared/components/LogoOnly';
import AddCircleIcon from '@mui/icons-material/AddCircle';

export const BusinessQuickLinks = () => {
    return (
        <Box width="100%">
            <Box sx={{
                display: 'flex',
                flexDirection: {
                    xs: 'row',
                    md: 'column'
                },
                alignItems: {
                    xs: 'center',
                    md: 'flex-start'
                }
            }}>
                <Box mt={4} mb={2}>
                    <LogoOnly />
                </Box>
                <Box sx={{ ml: { xs: 3, md: 0 } }}>
                    <Typography className={'title3'} mb={1}>
                        Create your Membership
                    </Typography>
                    <Typography fontWeight={500} className={'body2'} mb={2}>
                    Click here to create a new Membership for your business and list it on the Stakes marketplace.
                    </Typography>
                    <Box sx={{ display: { xs: 'none', md: 'initial' } }}>
                        <Button className={'button'}
                            component={Link}
                            to={`/token/create`}
                            variant="contained"
                            size="small"
                            color="primary"
                            startIcon={<AddCircleIcon />}
                        >
                            <Typography fontWeight={700} className={'button-label'}>
                                Create Membership
                            </Typography>
                        </Button>
                    </Box>
                </Box>
            </Box>

            <Box sx={{ display: { xs: 'block', md: 'none' }, mb: { xs: 3, md: 0 } }}>{/*mobile view (full width create button)*/}
                <Button className={'button w-100'}
                    component={Link}
                    to={`/token/create`}
                    variant="contained"
                    size="small"
                    color="primary"
                    startIcon={<AddCircleIcon />}
                >
                    <Typography fontWeight={700} className={'button-label'}>
                        Create Membership
                    </Typography>
                </Button>
            </Box>

            <Box my={5} sx={{ display: { xs: 'none', md: 'block' } }}>
                <Divider />
            </Box>

            <Box color="primary">
                <Typography className={'title3'} color={'#1E293B'} mb={1}>
                    Questions or problems with your Stakes Memberships?
                </Typography>
                <Typography fontWeight={500} className={'body2'} color={'#475569'} mb={2}>
                    Visit our Help Center to see the most frequently asked questions.
                </Typography>
                <Button color="primary"
                    style={{ padding: '0px' }}
                    component={Link}
                    to='/help-center'
                >
                    <Typography fontWeight={700} className={'button-label'} color={'#041E42'} mr={1}>
                        Help Center
                    </Typography>
                    <ArrowForwardIcon fontSize="small" />
                </Button>
            </Box>
        </Box>
    )
}
